/** AR04 copy (one group per control; a ticket edits only its own file). */
export const ar04PtBr = {
  title: 'Ativos e passivos de contrato',
  description:
    'Receita reconhecida antes do faturamento, liberações do ativo de contrato, passivos diferidos e adiantamentos reconciliados com os lançamentos efetivos.',
  prerequisite: '',
  reasons: {
    MISSING_ASSET_RECOGNITION: 'Receita vencida sem criação efetiva do ativo de contrato.',
    REVERSED_ASSET_RECOGNITION: 'Reconhecimento do ativo de contrato revertido neste período.',
    ASSET_RECOGNITION_UNTRACED:
      'Lançamento de reconhecimento sem vínculo com a conta do ativo de contrato.',
    MISCLASSIFIED_ASSET_RECOGNITION:
      'Reconhecimento debitado em uma conta diferente do ativo de contrato.',
    ASSET_RECOGNITION_AMOUNT_DIFFERENCE:
      'Valor reconhecido no ativo de contrato diverge do cronograma.',
    DUPLICATE_ASSET_RECOGNITION: 'Mais de um reconhecimento efetivo para a mesma obrigação.',
    MISSING_INVOICE_RELIEF: 'Faturamento efetivo sem baixa correspondente do ativo de contrato.',
    EXCESS_INVOICE_RELIEF: 'Baixa do ativo de contrato excede o faturamento efetivo.',
    MISSING_RELEASE: 'Liberação vencida sem contabilização efetiva no livro.',
    DUPLICATE_RELEASE: 'Mais de uma liberação efetiva para o mesmo lançamento neste período.',
    REVERSED_RELEASE: 'Liberação revertida neste período, sem reposição efetiva.',
    MISCLASSIFIED_RELEASE:
      'Liberação contabilizada em conta diferente da registrada para esta obrigação.',
    RELEASE_AMOUNT_MISMATCH: 'Valor da liberação no razão diverge do lançamento desta obrigação.',
    BALANCE_DIFFERENCE: 'Saldo da conta de passivo diverge do esperado pelo cronograma.',
    COVERAGE_LIMIT: 'Classificação não suportada; cobertura não pode ser confirmada.',
  },
  observations: {
    ADVANCE_CASH_NOT_EVALUATED_one:
      '{{count}} crédito de adiantamento de cliente ainda não avaliado por este controle',
    ADVANCE_CASH_NOT_EVALUATED_other:
      '{{count}} créditos de adiantamento de cliente ainda não avaliados por este controle',
  },
  unsupportedCoverageNote:
    'Parte da população ainda não pode ser confirmada por conta ausente, saldo inicial, classificação ou vínculo ambíguo, corte do plano de contas, moeda não suportada ou caixa antecipado não avaliado.',
  liabilityOverstated: 'Passivo a maior no razão',
  liabilityUnderstated: 'Passivo a menor no razão',
  openSchedule: 'Abrir contrato',
  openInvoice: 'Abrir fatura',
  evidence: {
    book: 'Livro',
    accounts: 'Contas',
    journals: 'Lançamentos',
  },
  listTruncated: 'Mostrando {{shown}} de {{total}} pendências.',
};

export const ar04En: typeof ar04PtBr = {
  title: 'Contract assets and liabilities',
  description:
    'Revenue recognized before billing, contract-asset relief, deferred liabilities, and advances reconciled with effective postings.',
  prerequisite: '',
  reasons: {
    MISSING_ASSET_RECOGNITION: 'Due revenue without an effective contract-asset creation.',
    REVERSED_ASSET_RECOGNITION: 'Contract-asset recognition was reversed this period.',
    ASSET_RECOGNITION_UNTRACED: 'Recognition journal is not linked to the contract-asset account.',
    MISCLASSIFIED_ASSET_RECOGNITION:
      'Recognition was debited to an account other than the contract asset.',
    ASSET_RECOGNITION_AMOUNT_DIFFERENCE:
      'Contract-asset recognition differs from the schedule amount.',
    DUPLICATE_ASSET_RECOGNITION:
      'More than one effective recognition exists for the same obligation.',
    MISSING_INVOICE_RELIEF: 'Effective billing has no matching contract-asset relief.',
    EXCESS_INVOICE_RELIEF: 'Contract-asset relief exceeds effective billing.',
    MISSING_RELEASE: 'Due release with no effective posting in this book.',
    DUPLICATE_RELEASE: 'More than one effective release for the same entry this period.',
    REVERSED_RELEASE: 'Release reversed this period, with no effective replacement.',
    MISCLASSIFIED_RELEASE:
      "Release posted to an account other than this obligation's recorded one.",
    RELEASE_AMOUNT_MISMATCH: "The ledger release amount differs from this obligation's entry.",
    BALANCE_DIFFERENCE: "The liability account's balance differs from what the schedule expects.",
    COVERAGE_LIMIT: 'Unsupported classification; coverage cannot be confirmed.',
  },
  observations: {
    ADVANCE_CASH_NOT_EVALUATED_one:
      '{{count}} customer advance credit not yet evaluated by this control',
    ADVANCE_CASH_NOT_EVALUATED_other:
      '{{count}} customer advance credits not yet evaluated by this control',
  },
  unsupportedCoverageNote:
    'Part of the population cannot be confirmed because of a missing account, opening balance, unsupported classification or ambiguous link, CoA cutoff, unsupported currency, or unchecked customer advances.',
  liabilityOverstated: 'Liability overstated in the ledger',
  liabilityUnderstated: 'Liability understated in the ledger',
  openSchedule: 'Open contract',
  openInvoice: 'Open invoice',
  evidence: {
    book: 'Book',
    accounts: 'Accounts',
    journals: 'Journals',
  },
  listTruncated: 'Showing {{shown}} of {{total}} pending items.',
};
